export default __webpack_public_path__ + "static/media/headerRecipe.09182d63.svg";